import { render, staticRenderFns } from "./ConfirmInfo.vue?vue&type=template&id=1fb22b06&scoped=true"
import script from "./ConfirmInfo.vue?vue&type=script&lang=ts"
export * from "./ConfirmInfo.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmInfo.vue?vue&type=style&index=0&id=1fb22b06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb22b06",
  null
  
)

export default component.exports